import { v4 as uuid } from 'uuid'

export const convertBase64 = (file) => {
   return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);

      fileReader.onload = () => {
         resolve(fileReader.result);
      };

      fileReader.onerror = (error) => {
         reject(error);
      };
   });
};

export const getMonthAndDay = (date) => {
   return new Date(date).toLocaleDateString("en-US", { month: 'long', day: 'numeric' })
}
export const getMonthAndDayAndWeekday = (date) => {
   return new Date(date).toLocaleDateString("en-US", { month: 'long', day: 'numeric', weekday: 'long' })
}

export const getTimeOf = (date) => {
   return new Date(date).toLocaleTimeString("en-US", { hour12: true, hour: "2-digit", minute: "2-digit" })
}

export const getNextDay = date => {
   var ms = new Date(date).getTime() + (1000 * 60 * 60 * 24);
   let newDate = new Date(ms);
   return getMonthAndDay(newDate)
}

export const unsetLocalTok = (tok) => {
   localStorage.removeItem("tok");
};

// gets params from URL
export const getQueryParameterByName = (name, url = window.location.href) => {
   name = name.replace(/[[\]]/g, "\\$&");
   var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
   if (!results) return null;
   if (!results[2]) return "";
   return decodeURIComponent(results[2].replace(/\+/g, " "));
}

export const isElementVisible = (el) => {
   var rect = el.getBoundingClientRect(),
      vWidth = window.innerWidth || document.documentElement.clientWidth,
      vHeight = window.innerHeight || document.documentElement.clientHeight,
      efp = function (x, y) { return document.elementFromPoint(x, y) };

   // Return false if it's not in the viewport
   if (rect.right < 0 || rect.bottom < 0
      || rect.left > vWidth || rect.top > vHeight)
      return false;

   // Return true if any of its four corners are visible
   return (
      el.contains(efp(rect.left, rect.top))
      || el.contains(efp(rect.right, rect.top))
      || el.contains(efp(rect.right, rect.bottom))
      || el.contains(efp(rect.left, rect.bottom))
   );
}

export const duplicateArrayElements = (arr, desiredLength) => {
   if (!arr.length) return []
   const duplicatedArray = [];
   while (duplicatedArray.length < desiredLength) {
      duplicatedArray.push(...arr);
   }
   return duplicatedArray.slice(0, desiredLength);
}

export const randomizeArray = (arr, recucive = true) => {
   if (recucive) {
      arr = arr.map(i => {
         if (Array.isArray(i)) {
            return randomizeArray(i)
         }
         return i;
      }
      )
   }
   return arr.sort(() => Math.random() - 0.5)
}

export const getTicketsOneLevel = (ticket_categories) => {
   const result = [];
   ticket_categories.forEach(category => {
      category.tickets.forEach(ticket => {
         result.push(ticket);
      });
   });
   return result;
}

export const extractAddons = (arr) => {
   let result = [];
   arr.forEach(ticket => {
      const addOns = ticket.addOns.map(addOn => {
         return { ...ticket, id: uuid(), type_id: addOn.id, ticket: addOn }
      })
      result = [...result, ticket, ...(addOns || [])];
   });
   return result;
}

export const getUniqueById = (arr) => {
   const ids = [];
   const resultArray = [];
   arr.map(item => {
      if (ids.includes(item.type_id)) return
      const obj = { ...item, amountOfTickets: arr.filter(i => i.type_id === item.type_id).length }
      resultArray.push(obj)
      ids.push(item.type_id)
   })
   return resultArray;
}

/**
 * this function counts the number of objects that have the same value for the given property and returns an
 * array of arrays each containing [propertyValue, count, object]
 * 
 * @param arr Array - the array to count
 * @param prop String - the name of the property to count its value
 * 
 * @return Array - the resulting array
 */
export const countObjectsByProp = (arr, prop) => {
   const counts = {};
   arr.forEach(item => {
      const val = item[prop];
      if (counts[val]) {
         counts[val][1]++;
      } else {
         counts[val] = [val, 1, item];
      }
   });
   return Object.values(counts);
};

export function filterProperties(obj, keys, exclude = true) {
   let newObj = {};

   if (exclude) {
      // Exclude specified keys
      newObj = { ...obj };
      keys.forEach(key => delete newObj[key]);
   } else {
      // Include only specified keys
      keys.forEach(key => {
         if (obj.hasOwnProperty(key)) {
            newObj[key] = obj[key];
         }
      });
   }

   return newObj;
}

export function formatNumber(number, formatOptions = { min: 0, max: 2 }) {
   return number.toLocaleString(undefined, {
      minimumFractionDigits: formatOptions.min,
      maximumFractionDigits: formatOptions.max,
   });
}

export function findNextIndex(arr, key) {
   let lastIndex = -1;

   for (let i = 0; i < arr.length; i++) {
      if (arr[i][key]) {
         lastIndex = i;
      }
   }

   return lastIndex === -1 ? 1 : lastIndex + 2;
}

export function countObjectsWithPropVal(arr, prop, val) {
   const count = arr.reduce((acc, obj) => {
      if (obj.hasOwnProperty(prop) && obj[prop] === val) {
         return acc + 1;
      } else {
         return acc;
      }
   }, 0);

   return count;
}

export function updateTags(title) {
   document.title = 'New York Venture Summit ' + title;
   // Update meta title
   const metaTitleTags = [
     document.querySelector('meta[name="title"]'),
     document.querySelector('meta[property="og:title"]'),
     document.querySelector('meta[property="twitter:title"]'),
   ];
   
   if (metaTitleTags) {
     metaTitleTags.forEach(tag => {
       tag.setAttribute('content', title);
     })
   }
 
   // Update meta URL
   const metaUrlTags = [
     document.querySelector('meta[property="og:url"]'),
     document.querySelector('meta[property="twitter:url"]'),
   ];
   if (metaUrlTags) {
     metaUrlTags.forEach(tag => {
       tag.setAttribute('content', window.location.href);
     })
   }
 }


